/*
* Copyright  2025-2026, Airspan
* All Rights Reserved
*
* This code is unpublished, confidential and proprietary to Airspan and may only be used in accordance with the appropriate
* license agreement. All other copying, modification, distribution, or
* reverse engineering are strictly prohibited.
*/

import { useSelector } from "react-redux";
import { useStoreDispatch } from "../../../../store/hooks";
import { Ioptions } from "../../../Shared/Filter/types";
import { useGetLabelsQuery, useCreateLabelMutation } from "../../../../store/api/devices/deviceApiSlice";
import { useState } from "react";
import { IKeyValue } from "../../types";
import { setBasicDialogOpenFor, setOpenToast } from "../../../../store/helpers/helperReducers";
import { errorMessage } from "../../../../utils/helpers";
import { labelPayload } from "../../helpers";
import { labelListSelector } from "../../../../store/api/devices/selectors";

export const useLabelData = () => {

    const dispatch = useStoreDispatch();
    const labelList: Ioptions[] = useSelector(labelListSelector) || [];
    const [createLabel, labelStatus] = useCreateLabelMutation();
    const {refetch } = useGetLabelsQuery();
    const [errorMsg, setErrorMsg] = useState<IKeyValue>();

    const [labelData, setLabelData] = useState<IKeyValue>({
        labelName: "",
    });
    const submitHandler = async () => {
        try {
            if (labelData.labelName === "") {
                setErrorMsg({ ...errorMsg, labelName: "Label Name is required!" });
                return;
            }
            let result: any;
            //const nameExists = data?.some((group) => group.name.trim().toLowerCase() === groupData.groupName.trim().toLowerCase());
            const nameExists = labelList.some((label: Ioptions) => label.text.trim().toLowerCase() === labelData.labelName.trim().toLowerCase());
            if (nameExists) {
                dispatch(setOpenToast({ openToast: true, toastType: "error", message: `Label:${labelData.labelName} already exists` }));
                return;
            }
            const payload = labelPayload(labelData);
            result = await createLabel(payload);
            if (result?.error || labelStatus.isError) throw result?.error;
            if (result.data?.status === 201 || result.data.name === labelData.labelName) {
                dispatch(setBasicDialogOpenFor(undefined));
                setLabelData({ labelName: "", domainKey: "Initial Domain" });
                dispatch(
                    setOpenToast({
                        openToast: true,
                        toastType: "success",
                        message: `Label: ${labelData.labelName} created successfully`,
                    })
                );
            }
            refetch();
        } catch (error: any) {
            dispatch(setBasicDialogOpenFor(undefined));
            dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) }));
        }
    };
        return {
            dispatch,
            submitHandler,
            labelStatus,
            labelData,
            setLabelData,
            errorMsg,
            setErrorMsg,
        };
    };